import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';

const FJVideoRemoveBgCustomExportContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.customExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.customExportData.exportProgress);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.exportVideoAction());
    }, [dispatch]);

    const goToBack = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.exportGoBackAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.cancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadCustomVideoAction(file));
        },
        [dispatch],
    );

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={goToBack}
            removeMore={removeMore}
            cancelExport={cancelExport}
            isCustom={true}
        />
    );
};

export default FJVideoRemoveBgCustomExportContainer;
